import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from '../window/window.token';

/** Unfinished features a page opts into by its URL: `?ai-retouch=1`, `?llm-chat=1` (`1` or `true` = on). */
export interface UrlFlags {
  readonly aiRetouch: boolean;
  readonly llmChat: boolean;
}

const ON_VALUES = ['1', 'true'];

export function readUrlFlags(search: string): UrlFlags {
  const params = new URLSearchParams(search);
  const on = (name: string): boolean => ON_VALUES.includes(params.get(name) ?? '');
  return { aiRetouch: on('ai-retouch'), llmChat: on('llm-chat') };
}

/** Root singleton read on first inject: in-app navigation keeps the flags, a reload without the param drops them. */
export const URL_FLAGS = new InjectionToken<UrlFlags>('URL_FLAGS', {
  providedIn: 'root',
  factory: (): UrlFlags => readUrlFlags(inject(WINDOW)?.location?.search ?? ''),
});
